import { Component } from '@angular/core';
import { GlobalButtonComponent } from '../../../shared/components/global-button/global-button.component';

@Component({
  selector: '[cards]',
  imports: [GlobalButtonComponent],
  templateUrl: './cards.component.html',
  styleUrl: './cards.component.scss',
})
export class CardsComponent {
  cardButton = {
    buttonLabel: 'Download',
    buttonUrl: 'assets/pdf/the-family-factor-t1d-survey-information-for-hcps.pdf',
    openInNewTab: true,
    buttonIcon: 'download-icon',
  };
}
